<template>
  <div class="myOrders">
    <a-skeleton :loading="loading" active>
      <div class="void">
        <p class="void--text">
          Você ainda não possui nenhum pedido para ser exibido.
        </p>
      </div>
      <div class="orders" v-for="(info, i) in infos" :key="i">
        <div class="verify" v-if="info.NRPedido.slice(0, 1) != 'v'">
          <div class="header">
            <div class="header__item">
              <p class="item__text">Pedido</p>
              <p class="item__text">{{ info.NRPedido }}</p>
            </div>
            <div class="header__item">
              <p class="item__text">Data do Pedido</p>
              <p class="item__text">
                {{ moment(info.dtPedido).format("DD/MM/YYYY HH:mm:ss") }}
              </p>
            </div>
            <div class="header__item header__item--status">
              <p
                class="header__orderStatus header__orderStatus--billed"
                v-if="info.StatusPedido == 'FATURADO'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--canceled"
                v-if="info.StatusPedido == 'CANCELADO'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--pending"
                v-if="info.StatusPedido == 'PENDENTE'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--finished"
                v-if="info.StatusPedido == 'ENTREGUE'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--approved"
                v-if="info.StatusPedido == 'APROVADO'"
              >
                {{ info.StatusPedido }}
              </p>
            </div>
          </div>
          <div class="body">
            <div class="subTable" v-for="(itens, i) in info.cjPedido" :key="i">
              <router-link to="" v-if="itens.urlImagem != null">
                <img
                  :src="itens.urlImagem"
                  :alt="itens.dsConjunto"
                  width="70px"
              /></router-link>
              <router-link to="" v-if="itens.urlImagem == null">
                <img
                  src="../../assets/produto-sem-imagem.jpg"
                  :alt="itens.dsConjunto"
                  width="70px"
                />
              </router-link>
              <div class="subTable__infos">
                <router-link to="" class="infos__text--link">
                  {{ itens.dsConjunto }}
                </router-link>
                <p class="infos__text" v-if="(itens.qtd = 1)">
                  {{ itens.qtd }} Unidade
                </p>
                <p class="infos__text" v-if="itens.qtd > 1">
                  {{ itens.qtd }} Unidades
                </p>
                <p class="infos__text">
                  Vendido e Entregue por
                  <span class="infos__text--color">Leveros</span>
                </p>
                <div v-for="(nf, i) in info.ovSap" :key="i" class="nf">
                  <div v-for="(link, i) in nf.nfs" :key="i" class="nf__items">
                    <p
                      class="infos__text"
                      v-if="info.StatusPedido == 'FATURADO'"
                    >
                      <a
                        class="infos__text--link"
                        :href="link.linkNfe"
                        target="_blank"
                        rel="noopener"
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19,14.5 L19,5.5 C19,4.67157288 18.3284271,4 17.5,4 L6.5,4 C5.67157288,4 5,4.67157288 5,5.5 L5,18.5 C5,19.3284271 5.67157288,20 6.5,20 L13.5,20 C14.3284271,20 15,19.3284271 15,18.5 C15,17.1192881 16.1192881,16 17.5,16 C18.3284271,16 19,15.3284271 19,14.5 L19,14.5 Z M18.5014408,16.7913481 C18.1948298,16.9255432 17.8561101,17 17.5,17 C16.6715729,17 16,17.6715729 16,18.5 C16,18.8561101 15.9255432,19.1948298 15.7913481,19.5014408 C16.9873685,18.9526013 17.9526013,17.9873685 18.5014408,16.7913481 L18.5014408,16.7913481 Z M4,5.5 C4,4.11928813 5.11928813,3 6.5,3 L17.5,3 C18.8807119,3 20,4.11928813 20,5.5 L20,14.5 C20,18.0898509 17.0898509,21 13.5,21 L6.5,21 C5.11928813,21 4,19.8807119 4,18.5 L4,5.5 Z M8.5,9 C8.22385763,9 8,8.77614237 8,8.5 C8,8.22385763 8.22385763,8 8.5,8 L15.5,8 C15.7761424,8 16,8.22385763 16,8.5 C16,8.77614237 15.7761424,9 15.5,9 L8.5,9 Z M8.5,12 C8.22385763,12 8,11.7761424 8,11.5 C8,11.2238576 8.22385763,11 8.5,11 L15.5,11 C15.7761424,11 16,11.2238576 16,11.5 C16,11.7761424 15.7761424,12 15.5,12 L8.5,12 Z M8.5,15 C8.22385763,15 8,14.7761424 8,14.5 C8,14.2238576 8.22385763,14 8.5,14 L13.5,14 C13.7761424,14 14,14.2238576 14,14.5 C14,14.7761424 13.7761424,15 13.5,15 L8.5,15 Z"
                          /></svg
                        >Ver nota fiscal</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="subTable__buttons">
              <div v-for="(rast, i) in info.ovSap" :key="i" class="nf">
                <div v-for="(track, i) in rast.nfs" :key="i" class="nf__item">
                  <a
                    v-if="info.StatusPedido == 'FATURADO'"
                    :href="`https://www.leveros.com.br/rastreioV2?notaFiscal=${track.Nf}&dataPedido=${track.DtNF}`"
                    target="_blank"
                    rel="noopener"
                  >
                    <button class="btn subTable__buttons--shipping">
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 254.215 254.215"
                        style="enable-background: new 0 0 254.215 254.215"
                        xml:space="preserve"
                        fill="#fff"
                      >
                        <g>
                          <path
                            d="M253.521,120.354l-19.709-42.577c-1.229-2.652-3.885-4.35-6.807-4.35h-61.982V36.312c0-4.142-3.357-7.5-7.5-7.5H7.5
                c-4.143,0-7.5,3.358-7.5,7.5v126.221c0,4.142,3.357,7.5,7.5,7.5h14.691c-1.256,2.75-2.205,5.667-2.799,8.712H7.5
                c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h11.893c3.51,18.016,19.406,31.659,38.436,31.659
                c19.027,0,34.922-13.644,38.432-31.659h62.596c3.51,18.016,19.405,31.659,38.434,31.659c19.026,0,34.92-13.644,38.43-31.659h10.996
                c4.143,0,7.5-3.358,7.5-7.5v-62.74C254.215,122.416,253.979,121.341,253.521,120.354z M158.855,178.744H96.26
                c-0.593-3.045-1.543-5.962-2.799-8.712h64.063c1.988,0,3.791-0.779,5.133-2.042C160.893,171.321,159.598,174.934,158.855,178.744z
                M15,43.812h135.023v111.221H81.447c-6.571-4.985-14.754-7.95-23.619-7.95s-17.05,2.965-23.621,7.95H15V43.812z M57.828,210.403
                c-13.324,0-24.164-10.838-24.164-24.159c0-13.323,10.84-24.162,24.164-24.162c13.322,0,24.16,10.839,24.16,24.162
                C81.988,199.565,71.15,210.403,57.828,210.403z M197.289,210.403c-13.323,0-24.162-10.838-24.162-24.159
                c0-13.323,10.839-24.162,24.162-24.162c13.321,0,24.158,10.839,24.158,24.162C221.447,199.565,210.61,210.403,197.289,210.403z
                M239.215,178.744h-3.496c-3.51-18.018-19.402-31.662-38.43-31.662c-13.535,0-25.486,6.904-32.523,17.374
                c0.162-0.615,0.258-1.257,0.258-1.923V88.427h57.189l17.002,36.729V178.744z"
                          />
                          <path
                            d="M211.066,95.302h-31.537c-4.143,0-7.5,3.358-7.5,7.5v20.85c0,4.142,3.357,7.5,7.5,7.5h41.428c0.011,0,0.015,0,0.02,0
                c4.143,0,7.5-3.358,7.5-7.5c0-1.343-0.353-2.603-0.971-3.693l-9.663-20.371C216.601,96.97,213.963,95.302,211.066,95.302z
                M187.029,116.151v-5.85h19.294l2.774,5.85H187.029z"
                          />
                        </g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                      </svg>
                      Rastrear Pedido
                    </button>
                  </a>
                  <button class="btn subTable__buttons--help">
                    <router-link to="/CallCenter">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 20 20"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        fill="#005A64"
                      >
                        <title>help_outline</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          id="Icons"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="Outlined"
                            transform="translate(-782.000000, -288.000000)"
                          >
                            <g
                              id="Action"
                              transform="translate(100.000000, 100.000000)"
                            >
                              <g
                                id="Outlined-/-Action-/-help_outline"
                                transform="translate(680.000000, 186.000000)"
                              >
                                <g>
                                  <polygon
                                    id="Path"
                                    points="0 0 24 0 24 24 0 24"
                                  ></polygon>
                                  <path
                                    d="M11,18 L13,18 L13,16 L11,16 L11,18 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z M12,6 C9.79,6 8,7.79 8,10 L10,10 C10,8.9 10.9,8 12,8 C13.1,8 14,8.9 14,10 C14,12 11,11.75 11,15 L13,15 C13,12.75 16,12.5 16,10 C16,7.79 14.21,6 12,6 Z"
                                    id="🔹-Icon-Color"
                                    fill="#005A64"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g></svg
                      >Preciso de ajuda</router-link
                    >
                  </button>
                </div>
              </div>
            </div>
            <div class="subTable__details">
              <a class="details__text" @click="detalhes(info.NRPedido)"
                >Ver detalhes do pedido</a
              >
            </div>
          </div>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      infos: [],
      cpfcnpj: null,
      loading: false,
    };
  },
  methods: {
    async getDados() {
      let dados = JSON.parse(localStorage.getItem("login"));

      this.cpfcnpj = dados.cpfCnj;
      try {
        this.loading = true;
        const response = await axios.get(
          `https://www.leverosintegra.com.br/Map/api/Orders/${this.cpfcnpj}`
        );

        this.infos = response.data;

        if (this.infos.length == 0) {
          document.getElementsByClassName("void")[0].style.display = "block";
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    detalhes(pedido) {
      window.location.href = `/account/orders/orderDetails?Pedido=${pedido}`;
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>


<style lang="scss" scoped>
.myOrders {
  .void {
    display: none;
    padding-top: 20px;

    &--text {
      color: var(--customGray-500);
    }
  }

  .orders {
    margin: 20px;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: var(--customGray-70);
      border-radius: 5px;
      padding: 15px 5px;
      margin-bottom: 10px;

      &__item {
        display: flex;
        flex-direction: column;
        width: initial;

        @media (min-width: 441px) {
          width: 25%;
        }

        .item {
          &__text:first-child {
            font-weight: bold;
          }

          &__text {
            font-size: 0.95rem;
          }
        }

        &--status {
          width: initial;
          display: flex;
          flex-direction: column;

          @media (min-width: 441px) {
            width: 10%;
          }

          p:first-child {
            font: 700 0.95rem "Soleto", sans-serif;
          }
        }
      }

      &__orderStatus {
        color: var(--customWhite);
        padding: 5px;
        border-radius: 5px;
        text-align: center;
        font: 700 0.95rem "Soleto", sans-serif;

        &--billed {
          background: #0694cc;
        }

        &--approved {
          background: #019231;
        }

        &--canceled {
          background: #be2323;
        }

        &--pending {
          background: #ec9420;
        }

        &--finished {
          background: #0694cc;
        }
      }
    }

    .body {
      border-bottom: 1px solid var(--customGray-100);
    }

    .subTable {
      display: flex;
      align-items: center;
      padding-bottom: 40px;

      &__infos {
        display: flex;
        flex-direction: column;
        line-height: 1.9;
        padding-left: 25px;
        color: var(--customGray-500);

        .infos {
          &__text {
            font-size: 0.95rem;

            &--color {
              color: var(--standardGreen);
              font: 700 0.95rem "Soleto", sans-serif;
            }

            &--link {
              color: var(--customDarkGreen);
              text-decoration: none;
              font: 700 0.95rem "Soleto", sans-serif;
              padding-bottom: 10px;
              display: flex;
              align-items: center;
            }
          }

          &__text:last-child {
            padding-top: 10px;

            &--link {
              text-decoration: underline;

              svg {
                vertical-align: middle;
                margin-right: 7px;
              }
            }
          }
        }
      }

      &__buttons {
        display: flex;
        justify-content: center;

        .btn {
          border-radius: 5px;
          padding: 10px;
          font-size: 0.95rem;
        }

        &--shipping {
          background: var(--standardGreen);
          color: var(--customWhite);
          margin-right: 15px;

          svg {
            vertical-align: middle;
            margin-right: 7px;
          }
        }

        &--help {
          border: 1px solid var(--standardGreen);
          color: var(--standardGreen);

          svg {
            margin-right: 7px;
            vertical-align: middle;
          }

          a {
            color: var(--standardGreen);
            text-decoration: none;
            font-size: 0.95rem;
          }
        }
      }

      &__details {
        display: flex;
        justify-content: center;
        padding: 20px 0;

        .details {
          &__text {
            color: var(--customGray-500);
            text-decoration: underline;
            font: 700 0.95rem "Soleto", sans-serif;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>